import React from 'react'

import { NotificationInfoFragment } from '@sketch/gql-types'

import { WorkspaceTile } from './FolderNotificationPreview.styles'
import {
  Card,
  Separator,
  Tile,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface FolderNotificationPreviewProps {
  /**
   * Media shown in the left folder tile — a contents grid for a folder that
   * still exists, or an icon glyph tile for a permanently-deleted one.
   */
  media: React.ReactNode
  /**
   * Name of the folder the notification is about. Omitted for permanently-
   * deleted folders — they no longer exist, so the tile stands unlabelled.
   */
  folderName?: string | null
  workspace: NotificationInfoFragment['workspace']
}

/**
 * Shared preview card for folder lifecycle notifications (archived, trashed,
 * permanently deleted). They differ only in the folder tile's media and whether
 * a folder name is available, so the layout — a folder tile beside the owning
 * workspace — lives here once.
 */
export const FolderNotificationPreview = ({
  media,
  folderName,
  workspace,
}: FolderNotificationPreviewProps) => (
  <Card>
    <TileWrapper>
      <Tile>
        {media}
        {folderName && <TileTitle>{folderName}</TileTitle>}
      </Tile>

      <Separator />

      <Tile>
        <WorkspaceTile
          size="96px"
          workspaceName={workspace?.name}
          src={workspace?.avatar?.large}
        />
        {workspace?.name && <TileTitle>{workspace.name}</TileTitle>}
      </Tile>
    </TileWrapper>
  </Card>
)
